const bar = document.querySelector('.ayume-product-bar');
const targets = [document.querySelector('.ayume-product-identity'), document.querySelector('.ayume-config-home')].filter(Boolean);
if (bar && targets.length && 'IntersectionObserver' in window) {
  const seen = new Map();
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => seen.set(e.target, e.isIntersecting));
    bar.classList.toggle('is-quiet', [...seen.values()].some(Boolean));
  });
  targets.forEach((t) => io.observe(t));
}
